module.exports = __webpack_public_path__ + "img/9.7462d5b2.jpg";